import React from 'react';

interface props {
    height?: number;
}

const LoadingAnimation = ({ height }: props) => {
    const s = { backgroundImage: "url(/img/JetBiddersNEW.gif)", backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', height: height ? height : '200px' };

    return <div style={s} />
}

export default LoadingAnimation;